import { ListItemIcon, ListItemText } from '@mui/material'
import MenuItem from './MenuItem'
import MenuList from './MenuList'
import MenuPopover from './MenuPopover'
import MenuRoot from './MenuRoot'
import MenuTrigger from './MenuTrigger'

/**
 * @example
 * import Menu from "global/components/MenuV2";
 * import { Button } from 'global/components/Button'
 *
 *  return (
 *      <Menu.Root arrow>
 *          <Menu.Trigger>
 *              <Button>Trigger</Button>
 *          </Menu.Trigger>
 *          <Menu.List>
 *              <Menu.Item href={`/example`}>Botão do menu</Menu.Item>
 *          </Menu.List>
 *      </Menu.Root>
 *  )
 */
const Menu = {
    Root: MenuRoot,
    Trigger: MenuTrigger,
    List: MenuList,
    Item: Object.assign(MenuItem, { Icon: ListItemIcon, Text: ListItemText }),
    /** Funciona como o Menu.List, mas é mais simples e não fecha automaticamente o menu */
    Popover: MenuPopover,
}

export default Menu
